import React from 'react';
// material ui
import AppBar from '@mui/material/AppBar';
import withStyles from '@mui/styles/withStyles';
import withRouter from 'src/config/withRouter';

const ColorAppBar = withStyles( theme => ({
    root: {
        backgroundImage: 'linear-gradient(to right, #49ceff , #00185a)',
        display:'none',
        [theme.breakpoints.down('md')]:{
            display:'block'
		}
    },
  }))(AppBar);

class GradientBar extends React.Component{
    constructor() {
        super();
    }

    render() {
    return(
        <div>
            <ColorAppBar position={this.props.position ? this.props.position : 'static'}>
                {this.props.children}
            </ColorAppBar>
        </div>
    )
    }
}


export default withRouter(GradientBar);